import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, of, ReplaySubject} from 'rxjs';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ActivatedRoute, Router} from '@angular/router';
import {FormHelperService} from '../../../shared/services/form-helper.service';
import {delay, distinctUntilChanged, filter, first, skipUntil, takeUntil, tap} from 'rxjs/operators';
import {Uuid} from '../../../shared/interface/response/uuid';
import {HttpErrorResponse} from '@angular/common/http';
import {Meeting} from '../../../shared/interface/meeting';
import {MeetingService} from '../../../shared/services/meeting.service';
import {Dictionary} from '../../../shared/interface/dictionary';
import {
  DICT_TYPE_MEETING_TYPE,
  DICT_TYPE_TERMINATION_TIME,
  DictService,
  MEETING_LEADER_ASF,
  MEETING_LEADER_INSURANCE_COMPANY,
  MEETING_PLACE_STATIONARY,
  MEETING_TYPE_ADA, MEETING_TYPE_ENTRANCE_EXAM,
  MEETING_TYPE_EXAM,
  MEETING_TYPE_IDD_TRAINING, MEETING_TYPE_MEETING,
  MEETING_TYPE_NEW_AGENT_TRAINING, MEETING_TYPE_OTHER,
  MEETING_TYPE_TRAINING,
  TERMINATION_TIME_IMMEDIATELY, ROOM_PGE
} from '../../../shared/services/dict.service';
import moment from 'moment';
import {ArrayValidators} from "../../../shared/validator/array-validators";
import {MeetingThematicScope} from "../../../shared/interface/meeting-thematic-scope";
import {select} from "@ngrx/store";
import {getCurrentRouteState} from "../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../shared/ngrx/route-serializer";
import {MatDialogRef} from "@angular/material/dialog";
import {DocumentAddDialogComponent} from "../../documents/document-add-dialog/document-add-dialog.component";
import {MeetingAddDialogComponent} from "../meeting-add-dialog/meeting-add-dialog.component";
import {co} from "@fullcalendar/core/internal-common";
import {connectableObservableDescriptor} from "rxjs/internal/observable/ConnectableObservable";
import {FileInput} from "ngx-material-file-input";
import {FileBase64} from "../../../shared/components/file-drag-and-drop/file-drag-and-drop.component";

@Component({
  selector: 'app-meeting-add',
  templateUrl: './meeting-add.component.html',
  styleUrls: ['./meeting-add.component.scss']
})
export class MeetingAddComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  readonly MEETING_TYPE_EXAM = MEETING_TYPE_EXAM;
  readonly MEETING_TYPE_IDD_TRAINING = MEETING_TYPE_IDD_TRAINING;
  readonly MEETING_TYPE_NEW_AGENT_TRAINING = MEETING_TYPE_NEW_AGENT_TRAINING;
  readonly MEETING_LEADER_ASF = MEETING_LEADER_ASF;
  readonly MEETING_TYPE_ENTRANCE_EXAM = MEETING_TYPE_ENTRANCE_EXAM;
  readonly ROOM_PGE = ROOM_PGE;
  readonly MEETING_TYPES = [
    MEETING_LEADER_ASF,
  ];


  @Input() meetingObject?: Meeting;
  @Input() typeOnlyKeys?: string[];
  @Input() name?: string ;
  @Input() statusEdit = true;
  @Input() meeting?: Observable<Meeting>;
  @Input() dialogRef?: MatDialogRef<MeetingAddDialogComponent>;
  @Input() dialogRefFront = false;
  @Output() closeModification = new EventEmitter<any>();
  @Output() meetingCreated = new EventEmitter<string>();

  meetingForm: FormGroup;
  statusControl: FormControl;
  typeControl: FormControl;
  leaderControl: FormControl;
  insuranceCompanyControl: FormControl;
  iddTrainingTrainerControl: FormControl;
  subjectControl: FormControl;
  examTypeControl: FormControl;
  startsAtControl: FormControl;
  thematicScopeFormArray: FormGroup[] = [];
  startsAtTimeControl: FormControl;
  endsAtControl: FormControl;
  endsAtTimeControl: FormControl;
  meetingTimeControl: FormControl;
  placeControl: FormControl;
  linkControl: FormControl;
  addressGroup: FormGroup;
  registrationsToControl: FormControl;
  registrationsToTimeControl: FormControl;
  limitOfPeopleControl: FormControl;
  minutesAssetsControl: FormControl;
  minutesLifeControl: FormControl;
  currentLeader?: Dictionary;
  currentType?: Dictionary;
  currentPlace?: Dictionary;
  meetingFormValid = false;
  processingRequest = false;
  thematicScopeValid = true;
  errors: any = {};
  meetingMinutesSelected: number = null;
  thematicScopeHelp: FormGroup;
  fileControl: FormControl;
  roomControl: FormControl;
  centralControl: FormControl;
  pgeControl: FormControl;
  mealControl: FormControl;
  accommodationControl: FormControl;
  meetingLeadingControl: FormControl;
  stationary = false;
  contentControl: FormControl;
  mealDetailControl: FormControl;
  accommodationDetailControl: FormControl;
  newTypeTraining = false;


  constructor(
    private meetingService: MeetingService,
    private snackBar: MatSnackBar,
    private router: Router,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private activatedRoute: ActivatedRoute,
    private dictService: DictService,
    private snack: MatSnackBar,
  ) {

    this.meetingForm = this.fb.group({
      status: this.statusControl = fb.control('', [Validators.required]),
      type: this.typeControl = fb.control('', [Validators.required]),
      leader: this.leaderControl = fb.control('', [Validators.required]),
      insuranceCompany: this.insuranceCompanyControl = fb.control('', [Validators.required]),
      iddTrainingTrainer: this.iddTrainingTrainerControl = fb.control('', [Validators.required]),
      subject: this.subjectControl = fb.control('', [Validators.required]),
      examType: this.examTypeControl = fb.control('', [Validators.required]),
      startsAt: this.startsAtControl = fb.control('', [Validators.required]),
      startsAtTime: this.startsAtTimeControl = fb.control('12:00', [Validators.required]),
      endsAt: this.endsAtControl = fb.control('', [Validators.required]),
      endsAtTime: this.endsAtTimeControl = fb.control('13:00', [Validators.required]),
      meetingTime: this.meetingTimeControl = fb.control(60),
      place: this.placeControl = fb.control('', [Validators.required]),
      link: this.linkControl = fb.control('', [Validators.required]),
      address: this.addressGroup = formHelper.generateAddressFormGroup(true, true),
      registrationsTo: this.registrationsToControl = fb.control('', [Validators.required]),
      registrationsToTime: this.registrationsToTimeControl = fb.control('12:00', [Validators.required]),
      limitOfPeople: this.limitOfPeopleControl = fb.control('', []),
      minutesAssets: this.minutesAssetsControl = fb.control(''),
      minutesLife: this.minutesLifeControl = fb.control(''),
      thematicScope: fb.array(this.thematicScopeFormArray, [ArrayValidators.minLength(1)]),
      room: this.roomControl = fb.control(''),
      central: this.centralControl = fb.control(false),
      pge: this.pgeControl = fb.control(false),
      meal: this.mealControl = fb.control(false),
      accommodation: this.accommodationControl =  fb.control(false),
      meetingLeading: this.meetingLeadingControl = fb.control('', [Validators.required]),
      file: this.fileControl = fb.control(''),
      filename: fb.control(''),
      content: this.contentControl = fb.control(''),
      mealDetail: this.mealDetailControl = fb.control(''),
      accommodationDetail: this.accommodationDetailControl = fb.control(''),
    });
  }

  ngOnInit(): void {
    this.activatedRoute.data
      .pipe(
        delay(0),
        first()
      )
      .subscribe((data: any) => {
        this.name = this.name ?? data.name ?? 'Egzaminy i szkolenia';
        this.typeOnlyKeys = this.typeOnlyKeys ?? data.typeOnlyKeys ?? null;
        if (this.typeOnlyKeys?.includes(MEETING_TYPE_EXAM) ) {
          this.dictService.get(MEETING_TYPE_EXAM, DICT_TYPE_MEETING_TYPE)
            .subscribe((dict: Dictionary) => {
              this.typeChanged(dict);
              this.typeControl.setValue(dict.id);
            });
          this.updateForm();
        }
      });

    this.meetingForm.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => this.meetingFormValid = this.meetingForm.valid);

    if (this.meeting) {
      this.meeting
        .pipe(takeUntil(this.destroyed$))
        .subscribe((meeting: Meeting) => {
          this.meetingObject = meeting;
          this.initialize(meeting);
        });
    } else {
      this.statusControl.disable();
      this.initialized.next(true);
      this.addressGroup.disable();
      this.linkControl.disable();
      this.insuranceCompanyControl.disable();
      this.iddTrainingTrainerControl.disable();
      this.leaderControl.disable();
      this.subjectControl.disable();
      this.examTypeControl.disable();
    }

    this.startsAtControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        skipUntil(this.initialized)
      )
      .subscribe((val) => {
        if (!this.registrationsToControl.value) {
          this.registrationsToControl.setValue(val);
        }
        this.endsAtControl.setValue(val);
      });

    this.meetingTimeControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        skipUntil(this.initialized)
      )
      .subscribe((minutes: number) => {
        if (minutes === this.meetingMinutesSelected) {
          return;
        }
        const startsAtTime = moment(this.startsAtTimeControl.value, 'HH:mm');
        startsAtTime.add(minutes, 'm');

        this.endsAtTimeControl.setValue(startsAtTime.format('HH:mm'));
      });

    this.startsAtTimeControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        skipUntil(this.initialized)
      )
      .subscribe((val: string) => {
        this.meetingMinutesSelected = null;
        const startsAtTime = moment(val, 'HH:mm');
        startsAtTime.add(this.meetingTimeControl.value, 'm');

        this.endsAtTimeControl.setValue(startsAtTime.format('HH:mm'));
        this.registrationsToTimeControl.setValue(val);
      });

    this.centralControl.valueChanges
      .pipe(
      takeUntil(this.destroyed$),
      skipUntil(this.initialized)
    )
      .subscribe((val: boolean) => {
        if (val){
          if (this.typeControl.value === MEETING_TYPE_IDD_TRAINING) {
            this.addressGroup.enable();
          }else{
            this.addressGroup.disable();
          }
          this.roomControl.enable();
          this.roomControl.setValidators([Validators.required]);
          this.pgeControl.setValue(false);
        }else {
          this.addressGroup.enable();
          this.roomControl.disable();
          this.roomControl.reset();
          this.roomControl.setValidators([]);
          this.roomControl.disable();
        }
        this.updateForm();
      });

    this.pgeControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        skipUntil(this.initialized)
      )
      .subscribe((val: boolean) => {
        if (val){
            this.addressGroup.disable();
            this.centralControl.setValue(false);
            this.roomControl.reset();
        }else {
          this.roomControl.reset();
          this.roomControl.setValidators([]);
          this.roomControl.enable();
        }
        this.updateForm();
    });

    this.endsAtTimeControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        skipUntil(this.initialized)
      )
      .subscribe((val: string) => {
        const startsAtTime = moment(this.startsAtTimeControl.value, 'HH:mm');
        const endsAtTime = moment(val, 'HH:mm');

        this.meetingMinutesSelected = null;
        setTimeout(() => {
          this.meetingMinutesSelected = endsAtTime.diff(startsAtTime, 'minutes');
          this.meetingTimeControl.setValue(this.meetingMinutesSelected);
        }, 0);
      });

    this.meetingForm.get('file').valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        filter((file?: FileInput) => !!file)
      )
      .subscribe((file: FileInput) => {

          this.fileControl.value.forEach((fileToRead: File) => {
            this.meetingForm.get('filename').setValue(fileToRead.name);
            this.meetingForm.get('content').reset('');
            const reader = new FileReader();
            reader.readAsDataURL(fileToRead);
            reader.onload = () => {
              this.meetingForm.get('content').setValue(
                this.meetingForm.get('content').value +
                (this.meetingForm.get('content').value ? ', ' : '') +
                (/base64,(.+)/.exec(reader.result.toString())[1])
              );
            };
          });
      });
  }

  initialize(meeting: Meeting): void {
    of(meeting)
      .pipe(
        delay(0),
        tap(() => {
          this.meetingForm.reset({
            status: meeting.status.id,
            type: meeting.type.id,
            leader: meeting.leader?.id,
            insuranceCompany: meeting.insuranceCompany?.id,
            iddTrainingTrainer: meeting.iddTrainingTrainer?.uuid,
            subject: meeting.subject,
            examType: meeting.examType?.id,
            startsAt: moment(meeting.startsAt),
            endsAt: moment(meeting.endsAt),
            place: meeting.place?.id,
            link: meeting.link,
            registrationsTo: moment(meeting.registrationsTo),
            limitOfPeople: meeting.limitOfPeople,
            minutesAssets: meeting.minutesAssets,
            minutesLife: meeting.minutesLife,
            room: meeting.room?.id,
            central: meeting.central,
            pge: meeting.pge,
            meal: meeting.meal,
            accommodation: meeting.accommodation,
            meetingLeading: meeting.meetingLeading,
            mealDetail: meeting.mealDetail,
            accommodationDetail: meeting.accommodationDetail,
          });
          meeting.thematicScope
            .forEach((thematicScope: MeetingThematicScope) => this.addThematicScope(thematicScope.thematicScopeSubject,
              thematicScope.thematicScopeStartsAt, thematicScope.thematicScopeStartsAtTime, thematicScope.thematicScopeEndsAtTime,
              thematicScope.thematicScopeEndsAt, thematicScope.thematicScopeMinutesTotal));

          const startsAt = moment(meeting.startsAt);
          const endsAt = moment(meeting.endsAt);
          const registrationsTo = moment(meeting.registrationsTo);

          this.startsAtTimeControl.setValue(startsAt.format('HH:mm'));
          this.endsAtTimeControl.setValue(endsAt.format('HH:mm'));
          this.registrationsToTimeControl.setValue(registrationsTo.format('HH:mm'));

          setTimeout(() => {
            this.meetingMinutesSelected = endsAt.diff(startsAt, 'minutes');
            this.meetingTimeControl.setValue(this.meetingMinutesSelected);
          }, 0);

          this.placeChanged(meeting.place);
          this.typeChanged(meeting.type);
          this.leaderChanged(meeting.leader);
          if (meeting.type.key === MEETING_TYPE_EXAM || meeting.type.key === MEETING_TYPE_ENTRANCE_EXAM) {
            this.typeOnlyKeys = [MEETING_TYPE_EXAM, MEETING_TYPE_ENTRANCE_EXAM];
          } else {
            this.typeOnlyKeys = [MEETING_TYPE_IDD_TRAINING, MEETING_TYPE_NEW_AGENT_TRAINING, MEETING_TYPE_ADA,
              MEETING_TYPE_TRAINING, MEETING_TYPE_MEETING, MEETING_TYPE_OTHER];
          }

          if (meeting.central || meeting.pge){
            this.addressGroup.disable();
          }
          if (meeting.address) {
            this.formHelper.setAddress(meeting.address, this.addressGroup);
          }
          this.updateForm();
        }),
        delay(0),
        tap(() => this.initialized.next(true))
      ).subscribe();
  }

  addThematicScope(thematicScopeSubject?: string, thematicScopeStartsAt?: string, thematicScopeStartsAtTime?: string,
                   thematicScopeEndsAtTime?: string, thematicScopeEndsAt?: string, thematicScopeMinutesTotal?: number ): void {
    this.thematicScopeFormArray.push(new FormGroup({
      thematicScopeSubject: new FormControl(thematicScopeSubject || '', [Validators.required]),
      thematicScopeStartsAt: new FormControl( thematicScopeStartsAt || '', [Validators.required]),
      thematicScopeStartsAtTime: new FormControl(thematicScopeStartsAtTime || '12:00', [Validators.required]),
      thematicScopeEndsAtTime: new FormControl(thematicScopeEndsAtTime || '13:00', [Validators.required]),
      thematicScopeEndsAt: new FormControl( thematicScopeEndsAt || '', [Validators.required]),
      thematicScopeMinutesTotal: new FormControl(thematicScopeMinutesTotal || 60, [Validators.required]),
    }));
    this.updateThematicScopeFormArray();
  }
  updateThematicScopeFormArray(): void {
    this.meetingForm.setControl('thematicScope', new FormArray(this.thematicScopeFormArray, [ArrayValidators.minLength(1)]));
  }
  removeThematicScope(index: number): void {
    this.thematicScopeFormArray.splice(index, 1);
    this.updateThematicScopeFormArray();
  }

  placeChanged(place: Dictionary): void {
    this.currentPlace = place;
    if (place.key === MEETING_PLACE_STATIONARY) {
      this.addressGroup.enable();
      this.linkControl.disable();
      this.stationary = true;
    } else {
      this.linkControl.enable();
      this.centralControl.setValue(false);
      this.addressGroup.disable();
      this.stationary = false;
    }
    this.updateForm();
  }

  leaderChanged(leader: Dictionary): void {
    this.currentLeader = leader;
    this.updateForm();
  }

  typeChanged(type: Dictionary): void {
    this.currentType = type;
    this.updateForm();
  }

  updateForm(): void {

    if (this.pgeControl.value) {
      this.addressGroup.disable();
    }

    if (this.currentType?.key === MEETING_TYPE_EXAM || this.currentType?.key === MEETING_TYPE_ENTRANCE_EXAM) {
      this.examTypeControl.enable();
    } else {
      this.examTypeControl.disable();
    }

    if (this.currentType?.key === MEETING_TYPE_EXAM || this.currentLeader?.key === MEETING_LEADER_INSURANCE_COMPANY
      || this.currentType?.key === MEETING_TYPE_ENTRANCE_EXAM) {
      this.insuranceCompanyControl.enable();
    } else {
      this.insuranceCompanyControl.disable();
    }
    if (this.currentType?.key === MEETING_TYPE_IDD_TRAINING  && this.currentPlace?.key === MEETING_PLACE_STATIONARY)
    {
      this.addressGroup.enable();
    }

    if (this.currentType?.key === MEETING_TYPE_IDD_TRAINING || this.currentType?.key === MEETING_TYPE_NEW_AGENT_TRAINING) {
      this.leaderControl.enable();
      this.subjectControl.disable();
      if (this.currentType?.key === MEETING_TYPE_IDD_TRAINING && this.currentPlace?.key !== MEETING_PLACE_STATIONARY ){
        this.subjectControl.enable();
        this.addressGroup.disable();
      }
    } else {
      this.subjectControl.disable();
      this.leaderControl.disable();
    }
    if (this.currentType?.key ===  MEETING_TYPE_ADA || this.currentType?.key ===  MEETING_TYPE_TRAINING ||
      this.currentType?.key ===  MEETING_TYPE_MEETING || this.currentType?.key ===  MEETING_TYPE_OTHER ){
      this.meetingLeadingControl.enable();
      this.subjectControl.enable();
      this.newTypeTraining = true;
    } else {
      this.newTypeTraining = false;
      this.registrationsToControl.enable();
      this.meetingLeadingControl.disable();
      if (this.currentType?.key === MEETING_TYPE_IDD_TRAINING && this.currentPlace?.key !== MEETING_PLACE_STATIONARY ){
        this.subjectControl.enable();
      }else {
        this.subjectControl.disable();
      }
    }

    if (this.currentType?.key === MEETING_TYPE_IDD_TRAINING && this.currentLeader?.key === MEETING_LEADER_ASF) {
      this.iddTrainingTrainerControl.enable();
    } else {
      this.iddTrainingTrainerControl.disable();
    }
    if (this.currentPlace?.key === MEETING_PLACE_STATIONARY && this.currentType?.key === MEETING_TYPE_IDD_TRAINING){
        this.meetingForm.get('thematicScope').enable();
        this.startsAtTimeControl.disable();
        this.startsAtControl.disable();
        this.endsAtControl.disable();
        this.endsAtTimeControl.disable();
        this.thematicScopeValid = false;

    } else {

      this.startsAtTimeControl.enable();
      this.endsAtTimeControl.enable();
      this.startsAtControl.enable();
      this.endsAtControl.enable();
      this.meetingForm.get('thematicScope').disable();
      this.thematicScopeValid = true;
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  save(): void {
    this.meetingFormValid = this.meetingForm.valid;
    if (!this.meetingForm.valid) {
      this.meetingForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }
    if (this.fileControl.value?.length  < 1) {
      this.meetingForm.get('filename').setValue(null);
      this.meetingForm.get('content').setValue(null);
    }
    const formData: any = {...this.meetingForm.value};

    if (this.thematicScopeValid) {
      formData.startsAt = moment(this.startsAtControl.value.format('YYYY-MM-DD')
        + this.startsAtTimeControl.value, 'YYYY-MM-DDHH:mm');
      formData.endsAt = moment(this.endsAtControl.value.format('YYYY-MM-DD')
        + this.endsAtTimeControl.value, 'YYYY-MM-DDHH:mm');
      formData.registrationsTo = moment(this.registrationsToControl.value.format('YYYY-MM-DD')
        + this.registrationsToTimeControl.value, 'YYYY-MM-DDHH:mm');

    } else {
      this.thematicScopeHelp = this.thematicScopeFormArray[0];
      this.startsAtControl.setValue(moment(this.thematicScopeHelp.get('thematicScopeStartsAt').value, 'YYYY-MM-DD HH:mm'));
      formData.startsAt = moment(this.startsAtControl.value.format('YYYY-MM-DD')
        + this.thematicScopeHelp.get('thematicScopeStartsAtTime').value, 'YYYY-MM-DD HH:mm');
      this.thematicScopeHelp = this.thematicScopeFormArray[this.thematicScopeFormArray.length - 1];
      this.endsAtControl.setValue(moment(this.thematicScopeHelp.get('thematicScopeEndsAt').value, 'YYYY-MM-DD HH:mm'));
      formData.endsAt = moment(this.endsAtControl.value.format('YYYY-MM-DD')
        + this.thematicScopeHelp.get('thematicScopeEndsAtTime').value, 'YYYY-MM-DD HH:mm');
      this.meetingTimeControl.setValue(0);
    }
    formData.startsAt.utc();
    formData.endsAt.utc();
    formData.registrationsTo.utc();
    if (this.processingRequest){
      return;
    }
    this.processingRequest = true;
    this.meetingService.sendForm(
      formData,
      this.meetingObject ? this.meetingObject.uuid : null
    )
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snackBar.open(this.meetingObject ? 'Pomyślnie zaktualizowano spotkanie' : 'Pomyślnie utworzono spotkanie', '', {
          duration: 2000,
        });

        if (this.dialogRef) {
          this.dialogRef.close();
        } else if (this.meeting) {
          this.closeModification.emit();
        } else {
          if (  window.location.href.includes('egzaminy-szkolenia') ){
            this.router.navigate(['/egzaminy-szkolenia/szczegoly', response.uuid]);
          }else {
            this.router.navigate(['/szkolenie/szczegoly', response.uuid]);
          }
        }
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        this.snackBar.open('Podczas przesyłania formularza wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.errors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.meetingForm, this.errors);
        }
      });
  }

  cancel(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }

    if (!this.meetingObject) {
      if (  window.location.href.includes('egzaminy-szkolenia') ){
        this.router.navigate(['/egzaminy-szkolenia/egzaminy']);
      }else {
        this.router.navigate(['/szkolenie']);
      }
    } else {
      this.closeModification.emit();
    }
  }

}
